import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { toast as sonnerToast } from 'sonner';
import { registerToastHandler } from '@shared/lib/toast';
import App from './App';
import './index.css';

// Shared logic-layer toasts render through sonner on web.
registerToastHandler(sonnerToast);

createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
